import { cn } from '@/lib/utils';
import { ArrowUpRight } from 'lucide-react';

export default function AnimatedArrow({
    className,
    strokeWidth = 1,
}: {
    className?: string;
    strokeWidth?: number;
}) {
    return (
        <span
            className={cn(
                'relative flex h-5 w-5 items-center justify-center overflow-hidden group-hover:transition-all max-sm:h-4 max-sm:w-4',
                className,
            )}
        >
            <ArrowUpRight
                strokeWidth={strokeWidth}
                className="absolute h-9 w-9 transform transition-transform duration-500 group-hover:-translate-y-full group-hover:translate-x-full origin-center max-sm:h-6 max-sm:w-6"
            />
            <ArrowUpRight
                strokeWidth={strokeWidth}
                className="absolute h-9 w-9 translate-y-full -translate-x-full text-white transform transition-transform duration-500 group-hover:translate-x-0 group-hover:translate-y-0 group-hover:rotate-0 origin-center max-sm:h-6 max-sm:w-6"
            />
        </span>
    );
}
